import { ReactNode } from 'react';
import { cn } from './cn';

export type Tone = 'neutral' | 'ok' | 'warn' | 'danger' | 'accent' | 'violet';

const toneClasses: Record<Tone, string> = {
  neutral: 'bg-layer text-fg-soft ring-line',
  ok: 'bg-ok/15 text-ok ring-ok/25',
  warn: 'bg-warn/15 text-warn ring-warn/25',
  danger: 'bg-danger/15 text-danger ring-danger/25',
  accent: 'bg-accent/15 text-accent ring-accent/25',
  violet: 'bg-violet/15 text-violet ring-violet/25',
};

export const Badge = ({
  tone = 'neutral',
  title,
  className,
  children,
}: {
  tone?: Tone;
  title?: string;
  className?: string;
  children: ReactNode;
}) => (
  <span
    title={title}
    className={cn(
      'inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-semibold ring-1 ring-inset',
      toneClasses[tone],
      className,
    )}
  >
    {children}
  </span>
);

export default Badge;
